import { ApiResult, request, safeRequest } from '@synergy/api';

import { ContactDocumentsApi } from '../documents/api/contact-detail-documents-api';
import { ContactOverviewApi } from '../overview/api/contact-detail-overview-api';
import { ContactPermissionsApi } from '../permissions/api/contact-detail-permissions-api';

export class ContactDetailApi {
    constructor(protected baseUrl: string) {
        this.Overview = new ContactOverviewApi(this.baseUrl);
        this.Permissions = new ContactPermissionsApi(this.baseUrl);
        this.Documents = new ContactDocumentsApi(this.baseUrl);
    }

    public Overview: ContactOverviewApi;
    public Permissions: ContactPermissionsApi;
    public Documents: ContactDocumentsApi;

    public delete(contactId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/contacts/${contactId}`),
            () => null
        );
    }

    public lock(contactId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/contacts/${contactId}/lock`),
            () => null
        );
    }

    public unlock(contactId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/contacts/${contactId}/unlock`),
            () => null
        );
    }
}
